import { h6Styles } from 'components/reusable-css';
import styled from 'styled-components';
import { deviceBreakpoints, variables } from 'variables';

export const PassSC = styled.div`
  background: white;
  width: 100%;
  border-bottom: 4px solid ${(props) => props.theme.primaryDarkColor};
  padding: ${variables.pageContentPadding}px;
  padding-top: 60px;
  @media only screen and (max-width: ${deviceBreakpoints.mobile}px) {
    padding: ${variables.pageContentPadding}px;
  }
`;

export const ChangePasswords = styled.div`
  margin-top: 20px;
  margin-bottom: 40px;
`;

export const FormDiv = styled.div`
  padding-bottom: 2.4em;
`;

export const Label = styled.h6`
  padding-top: 2.8rem;
  font-weight: bold;
  font-size: ${(props) => props.theme.default?.h6};
  ${(props) => h6Styles(props.theme.resolutions)};
  @media only screen and (max-width: 899px) {
    padding-top: 2rem;
  }
`;

export const LabelDescription = styled.h6`
  padding-top: 2.8rem;
  font-size: ${(props) => props.theme.default?.h6};
  ${(props) => h6Styles(props.theme.resolutions)};
  @media only screen and (max-width: 899px) {
    padding-top: 0;
  }
`;
